"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports._Label = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("@emotion/react");

var react_2 = require("react");

var form_control_1 = require("./form-control");

var components_utils_1 = require("@conte-ltd/components-utils");

function _Label(props, fwRef) {
  var _a = (0, form_control_1.useFormControl)().labelProps,
      labelProps = _a === void 0 ? {} : _a;
  return (0, jsx_runtime_1.jsx)("label", __assign({
    css: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        &[for] {\n          cursor: default;\n        }\n      "], ["\n        &[for] {\n          cursor: default;\n        }\n      "]))),
    ref: fwRef
  }, (0, components_utils_1.mergeProps)(labelProps, props)), void 0);
}

exports._Label = _Label;
exports.Label = (0, react_2.forwardRef)(_Label);
var templateObject_1;